/* global google, GoogleMapClass, jQuery */
(function ($) {

  var MarkerClusterer = require('./global/marker-clusterer');

  //window.initialize = initialize;
  window.initialize = initMap;

  var folder = location.pathname.replace(/^(\/opencms\/opencms)?(.*)/, '$2').replace('index.html', '');
  var map = $('#product-map');
  var itemsMap = window.itemsMap = new GoogleMapClass();

  $.getJSON('/opencms/opencms/sys/bloky/items.json', {
    folder: folder,
    all: true,
    type: getItemsType(folder)
  }, (data) => {
    //console.log(data);
    renderCountrySelect(data.items);
    itemsMap.set('places', data.items);
    showMap();
  });

  /*if (isToggle())
    $('#toggle-map').click(toggleMap);
  else*/

  function getItemsType (folder) {

    var parts = folder.split('/').filter(String);
    var item = parts[parts.length - 1];
    var types = {
      def: 8332,
      viza: 8322
    };

    return types[item] || types.def;
  }

  function getItemUrl (file) {
    return (location.pathname.replace('index.html', '') + '/' + file).replace(/\/\//g, '/');
  }

  function renderCountrySelect (countries) {

    var block = $('#select-country');

    var select = $('<select id="form-control-select-country" class="form-control"/>').change(function () {
      if ($(this).val() == 'default')
        return;
      else
        location.pathname = $(this).val();
    });

    $('<option>', {
        text: '-- Vyberte zemi --',
        value: 'default'
    }).appendTo(select);

    countries.forEach(function (country) {
      $('<option>', {
        text: country.title,
        value: getItemUrl(country.name)
      }).appendTo(select);
    });

    select.appendTo(block);

    window.selectOrNative($('#maps-country, #product-map').parent());

    /*if (!Modernizr.touchevents) {
      $('#maps-country, #product-map').parent().find('select').each(function(){
        new Select({
        el: this,
        alignToHighlighted: 'always'
        });
      });
    }*/
  }

  function showMap (callback) {
    //map.slideDown(500, () => {
    map.show();
    map.addClass('opened');
    itemsMap.loadMapApi('initialize');
    if (typeof callback === 'function')
      callback();
    //});
  }

 /* function hideMap (callback) {
    map.slideUp(500, () => {
      map.removeClass('opened');
      if (typeof callback === 'function')
        callback();
    });
  }*/

  /*function toggleMap () {
    if (!map.hasClass('opened'))
      showMap(() =>
        $('#toggle-map').html('<i class="fa fa-eye-slash"></i> Skrýt mapu')
      );
    else
      hideMap(() =>
        $('#toggle-map').html('<i class="fa fa-eye"></i> Zobrazit mapu')
      );
  }*/

  /*function isToggle () {
    return $('#toggle-map').length > 0;
  }*/

  /*function initialize () {
    console.log('Initialize');

    if (itemsMap.get('instance'))
      return false;

    var bounds = new google.maps.LatLngBounds();
    var markers = [];
    var options = {
          center: new google.maps.LatLng(10, 60),
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          zoom: 2,
          minZoom: 1
        };
    var markerEventHandlers = {
      click () {
        location.pathname = this.url || this.get('url');
      }
    };

    itemsMap.set('instance', new google.maps.Map(document.getElementById('product-map'), options));
    //itemsMap.setLabelPrototype();
    itemsMap.get('places').forEach((place) => {

      if (!place.latitude || !place.longitude)
        return false;

      bounds.extend(new google.maps.LatLng(place.latitude, place.longitude));

      var marker = itemsMap.drawMarker({
        icon: '/sys/images/default-map-marker.svg',
        x: place.latitude,
        y: place.longitude,
        name: place.title,
        url: getItemUrl(place.name)
      }, markerEventHandlers);

      markers.push(marker);

      //itemsMap.drawLabel(marker, markerEventHandlers);
    });

    var cluster = new MarkerClusterer(itemsMap.get('instance'), markers);

    itemsMap.get('instance').fitBounds(bounds);
  }*/

  function initMap() {
    var center = new google.maps.LatLng(49.195060, 16.606837);
    var options = {
      'zoom': 2,
      'center': center,
      'mapTypeId': google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map(document.getElementById("product-map"), options);

    var markers = [];

    var image = {
      url: '/sys/images/default-map-marker.png',
      size: new google.maps.Size(250.34375, 414.15625),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 34),
      scaledSize: new google.maps.Size(20, 32)
    }

    itemsMap.get('places').forEach((item) => {
      var latLng = new google.maps.LatLng(item.latitude,
          item.longitude);
      var marker = new google.maps.Marker({
        'position': latLng,
        'url': item.name,
        'nap': map,
        'title': item.title,
        icon: image
      });
      marker.addListener('click', function() {
        window.location.href = this.url;
      });
        markers.push(marker);
    });

    var mcOptions = {gridSize: 50, maxZoom: 15};

    var mc = new MarkerClusterer(map, markers, mcOptions);
  }


})(jQuery);
